import {Ease} from "../core/Animatable";
import {Container} from "../core/Container";
import {Callback} from "../core/Reflection";

export class BottomHud extends Container {

    private _normalY: number = 0;

    public onLayout() {
        this._normalY = this.y;
    }

    public show(cb?: Callback) {
        this.visible = true;
        this.y = this._normalY + this.height;
        this.killTweens();
        this.moveYTo(this._normalY, 0.4, Ease.backOut, cb);
    }

    public hide(cb?: Callback) {
        this.y = this._normalY;
        this.killTweens();
        this.moveYTo(this._normalY + this.height, 0.2, Ease.sineIn, () => {
            this.visible = false;
            if (cb) {
                cb();
            }
        });
    }
}
